import { PUBLIC_BASE_URL, GAME_ID } from '@config/game.js'
import { requestAll } from '@helpers/requestAll.js'
import { queryString } from '@helpers/utils.js'
import { createClient } from '@services'

const { get } = createClient()

/* API request to get all user's teams */
export async function getCogsTeamsRequest() {
  const { data } = await requestAll(`${PUBLIC_BASE_URL}/cogs/me/teams`)
  return data
}

/* API request to get user's games */
export async function getGameTeamsRequest() {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/me/games${queryString({ id: GAME_ID })}`
  )
  return data
}

/* API request to get user's mods */
export async function getModTeamsRequest() {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/me/mods${queryString({ game_id: GAME_ID })}`
  )
  return data
}
